export enum STORE_ACTOR_FIELD_NAMES {
  ADDRESS = 'address',
}
